import useMediaQuery from "@material-ui/core/useMediaQuery";
import LogoutIcon from "@mui/icons-material/Logout";
import MenuIcon from "@mui/icons-material/Menu";
import AppBar from "@mui/material/AppBar";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import CssBaseline from "@mui/material/CssBaseline";
import Divider from "@mui/material/Divider";
import Drawer from "@mui/material/Drawer";
import FormControl from "@mui/material/FormControl";
import FormControlLabel from "@mui/material/FormControlLabel";
import FormGroup from "@mui/material/FormGroup";
import IconButton from "@mui/material/IconButton";
import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import ListItemButton from "@mui/material/ListItemButton";
import ListItemText from "@mui/material/ListItemText";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import Switch from "@mui/material/Switch";
import Toolbar from "@mui/material/Toolbar";
import Tooltip from "@mui/material/Tooltip";
import Typography from "@mui/material/Typography";
import PropTypes from "prop-types";
import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import i18n from "../../i18n/config";
import { loggedOut } from "../../store/reducer/currentUserSlice";
const drawerWidth = 300;

function DrawerAppBar(props) {
  const isMediumScreen = useMediaQuery("(min-width: 960px)");
  const { t } = useTranslation();
  const [checked, setChecked] = useState(false);
  const navItems = useSelector((state) => state.currentUser.navigation);
  console.log(navItems)
  const role = useSelector((state) => state.currentUser.roleAllowed);

  let navigates = useNavigate();
  //*******permission to visite page on basis of role.**********//

  //*******Drawer**********//
  const { window } = props;
  const [mobileOpen, setMobileOpen] = React.useState(false);
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const handleDrawerToggle = () => {
    setMobileOpen((prevState) => !prevState);
  };

  const handleChange = () => {
    setChecked(!checked);
    i18n.changeLanguage(checked ? "en" : "ur");
  };

  const container =
    window !== undefined ? () => window().document.body : undefined;

  //*********Logout Functionality**********//
  const handleLogout = () => {
    dispatch(loggedOut());
    navigate("/login");
  };

  //********* Account functinality**********//
  const [openAccount, setOpenAccount] = useState(false);
  const [subMenuOpen, setSubMenuOpen] = useState(false);
  const [anchorElAccount, setAnchorElAccount] = useState(null);

  const handleClickAccount = (event) => {
    setAnchorElAccount(event.currentTarget);
    setOpenAccount(true);
    setSubMenuOpen(false); // Close the submenu when clicking "Account"
  };
  const handleCloseAccount = () => {
    setAnchorElAccount(null);
    setOpenAccount(false);
  };
  const handleSubMenuClick = () => {
    setSubMenuOpen(!subMenuOpen); // Toggle submenu visibility
  };
  const handleMenuItemClick = (path) => {
    if (mobileOpen) {
      handleDrawerToggle();
    }
    navigate(path); // Assuming navigate is a function to handle routing
    setSubMenuOpen(false); // Close the submenu
    setOpenAccount(false); // Close the top-level menu
  };
  const navBarAccount = () => (
    <span>
      <Button
        id="demo-positioned-button"
        aria-controls={openAccount ? "demo-positioned-menu" : undefined}
        aria-haspopup="true"
        aria-expanded={openAccount ? "true" : undefined}
        onClick={handleClickAccount}
        sx={{ color: "white", marginLeft:"1rem" }}
      >
        Account
      </Button>
      <Menu
        id="demo-positioned-menu"
        aria-labelledby="demo-positioned-button"
        anchorEl={anchorElAccount}
        open={openAccount}
        onClose={handleCloseAccount}
        anchorOrigin={{
          vertical: "top",
          horizontal: "left",
        }}
        transformOrigin={{
          vertical: "top",
          horizontal: "left",
        }}
      >
        <MenuItem onClick={handleSubMenuClick}>Levels</MenuItem>
        {subMenuOpen && (
          <Menu
            anchorEl={anchorElAccount}
            open={subMenuOpen}
            onClose={handleCloseAccount}
            anchorOrigin={{
              vertical: "top",
              horizontal: "right",
            }}
            transformOrigin={{
              vertical: "top",
              horizontal: "left",
            }}
          >
            <MenuItem onClick={() => handleMenuItemClick("/level-one")}>
              Level 1
            </MenuItem>
            <MenuItem onClick={() => handleMenuItemClick("/level-two")}>
              Level 2
            </MenuItem>
            <MenuItem onClick={() => handleMenuItemClick("/level-three")}>
              Level 3
            </MenuItem>
          </Menu>
        )}
        <MenuItem onClick={() => handleMenuItemClick("/opening-balance")}>
          Opening Balance
        </MenuItem>
        <MenuItem onClick={() => handleMenuItemClick("/cash-book")}>
          Cash Book
        </MenuItem>
        <MenuItem onClick={() => handleMenuItemClick("/trial-balance")}>
          Trial Balance
        </MenuItem>
        <MenuItem onClick={() => handleMenuItemClick("/ledger")}>
          Ledger
        </MenuItem>
        <MenuItem onClick={() => handleMenuItemClick("/voucher")}>
          Voucher
        </MenuItem>
      </Menu>
    </span>
  );

  //********* Inventory functinality**********//
  const [openInventory, setOpenInventory] = useState(false);
  const [subMenuOpenInven, setSubMenuOpenInven] = useState(false);
  const [anchorElInventory, setAnchorElInventory] = useState(null);

  const handleClickInventory = (event) => {
    setAnchorElInventory(event.currentTarget);
    setOpenInventory(true);
    setSubMenuOpenInven(false); // Close the submenu when clicking "Inventory"
  };
  const handleCloseInventory = () => {
    setAnchorElInventory(null);
    setOpenInventory(false);
  };
  const handleSubMenuClickInven = () => {
    setSubMenuOpenInven(!subMenuOpenInven); // Toggle submenu visibility
  };
  const handleMenuItemClickInven = (path) => {
    if (mobileOpen) {
      handleDrawerToggle();
    }
    navigate(path); // Assuming navigate is a function to handle routing
    setSubMenuOpenInven(false); // Close the submenu
    setOpenInventory(false); // Close the top-level menu
  };

  const navBarInventory = () => (
    <span>
      <Button
        id="demo-positioned-button"
        aria-controls={openInventory ? "demo-positioned-menu" : undefined}
        aria-haspopup="true"
        aria-expanded={openInventory ? "true" : undefined}
        onClick={handleClickInventory}
        sx={{ color: "white", marginLeft: "1rem" }}
      >
        Inventory
      </Button>
      <Menu
        id="demo-positioned-menu"
        aria-labelledby="demo-positioned-button"
        anchorEl={anchorElInventory}
        open={openInventory}
        onClose={handleCloseInventory}
        anchorOrigin={{
          vertical: "top",
          horizontal: "left",
        }}
        transformOrigin={{
          vertical: "top",
          horizontal: "left",
        }}
      >
        <MenuItem onClick={() => handleMenuItemClickInven("/Inventory")}>
          Production
        </MenuItem>
        {/* <MenuItem onClick={() => handleMenuItemClickInven("/purchase_order")}>
          PurchaseOrder
        </MenuItem> */}
        {/* <MenuItem onClick={() => handleMenuItemClickInven("/rawMaterial")}>
        Raw Material
        </MenuItem> */}
        <MenuItem onClick={() => handleMenuItemClickInven("/recipe")}>
          Reciepe
        </MenuItem>
        {/* <MenuItem onClick={() => handleMenuItemClickInven("/suppliers")}>
          Supplier
        </MenuItem> */}
      </Menu>
    </span>
  );

   //********* Language Changes functionality**********//
   const navBarTranslate = () => (
    <span>
      <Button
        id="demo-positioned-button"
        aria-haspopup="true"
        sx={{ color: "white", marginLeft:"0rem"}}
      >
          <Box
            sx={{
              flexGrow: 2.5,
              display: "flex",
              justifyContent: "start",
              marginLeft: "0rem",
            }}
          >
            <FormControl component="fieldset" variant="standard">
              <FormGroup>
                <FormControlLabel
                  control={
                    <Switch
                      checked={checked}
                      onChange={handleChange}
                      inputProps={{ "aria-label": "controlled" }}
                      color="secondary"
                    />
                  }
                  label="UR"
                />
              </FormGroup>
            </FormControl>
          </Box>
      </Button>
    </span>
  );
  
  const drawer = (
    <Box
      // onClick={handleDrawerToggle}
      sx={{ textAlign: "start", marginLeft: "0rem" }}
    >
      <div style={{ display: "flex", justifyContent: "center" }}>
            <Typography sx={{color:'white', fontWeight:'bold'}}> NBF</Typography>
      </div>
      <Divider />
      <List>
        {navItems.map((item) => (
          <ListItem key={item} disablePadding>
            <ListItemButton sx={{ textAlign: "start", marginLeft: "0.3rem" }}>
              <ListItemText
                onClick={() => {
                  handleDrawerToggle();
                  navigate(`/${item.toLowerCase()}`);
                }}
              >
                {t(item)}
              </ListItemText>
            </ListItemButton>
          </ListItem>
        ))}
      </List>
      {role.isAccounting   && navBarAccount()}
      {role.isAccounting   && navBarInventory()}
      {role.isAccounting   && navBarTranslate()}

    </Box>
  );


  

  
  return (
    <Box sx={{ display: "flex",  }}>
      <CssBaseline />
      <AppBar component="nav" style={{ zIndex: 900, }}>
        <Toolbar>
          <IconButton
            color="inherit"
            aria-label="Inventory drawer"
            edge="start"
            onClick={handleDrawerToggle}
            sx={{ mr: 1, display: { sm: "none" } }}
          >
            <MenuIcon />
          </IconButton>
      <div style={{ display: 'flex', justifyContent: 'center' }}>
      {/* {isMediumScreen ? (
                <img
                src={require('../../assets/Images/logo.png')}
                width={70}
                height={70}
                alt="Logo"
              />
        
      ) : (
        <Typography sx={{fontWeight:'bold',width:'260px'}}>National Bake Factory</Typography>
      )} */}
      </div>

          {/******Nav bar Items*********/}
          <Box sx={{
              display: { 
                xs: 'none', // Hide on extra small screens
                sm: 'block', // Show on small screens and above
              },
              width: {
                xs: '100%', // Full width on extra small screens
                sm: '100%', // 
              },
          }}>
            {i18n.language !== "ur"
              ? navItems.map((item, index) => (
                  <Button
                    key={index}
                    sx={{ color: "#fff", marginLeft: "1rem" }}
                    onClick={() => navigate(`/${item.toLowerCase()}`)}
                  >
                    {t(item)}
                  </Button>
                ))
              : [...navItems].reverse().map((item, index) => (
                  <Button
                    key={index}
                    sx={{ color: "#fff", marginLeft: "1rem" }}
                    onClick={() => navigate(`/${item.toLowerCase()}`)}
                  >
                    {t(item)}
                  </Button>
                ))}
            {role.isAccounting   && navBarAccount()}
            {role.isAccounting   && navBarInventory()}
            {role.isAccounting   && navBarTranslate()}
          </Box>



          {/******Log out button.*********/}
          <Box sx={{ display: { xs: "block", sm: "block" } }}>
            <Tooltip title="Logout">
              <LogoutIcon onClick={handleLogout} sx={{}}></LogoutIcon>
            </Tooltip>
          </Box>
        </Toolbar>
      </AppBar>
      <Box component="nav">
        <Drawer
          container={container}
          variant="temporary"
          open={mobileOpen}
          onClose={handleDrawerToggle}
          ModalProps={{
            keepMounted: true, // Better open performance on mobile.
          }}
          sx={{
            display: { xs: "block", sm: "none" },
            "& .MuiDrawer-paper": {
              boxSizing: "content-box",
              width: 170,
              display: "flex",
              flexDirection: "column",
              fontSize: "15px",
              color: "white",
              backgroundColor: "#1976D2",
            },
          }}
        >
          {drawer}
        </Drawer>
      </Box>
      <Toolbar />
      <Box component="main" sx={{ p: 3 }}></Box>
    </Box>
  );
}

DrawerAppBar.propTypes = {
  /**
   * Injected by the documentation to work in an iframe.
   * You won't need it on your project.
   */
  window: PropTypes.func,
};

export default DrawerAppBar;
